import React, { useState, useEffect } from "react";
import FBookingCard from "./FBookingCard";
import "../style/f-booking-cards.css";
import { Form } from "react-bootstrap";
import { Icon } from "@iconify/react/dist/iconify.js";
import ConfirmRedeemModal from "../modal/ConfirmRedeemModal";
import { usePostMarkAsRedeemMutation } from "../../../rtk-query/slices/finance/financeSlice";
import { toast } from "react-toastify";
import NoBookingCard from "./NoBookingCard";

function FBookingCardsList({ bookings, searchVoucherId, setSearchVoucherId }) {
  const [showConfirmRedeemModal, setShowConfirmRedeemModal] = useState(false);
  const [postMarkAsRedeem, { isLoading: isPostMarkAsRedeemLoading }] =
    usePostMarkAsRedeemMutation();

  // Initialize the checked state for each booking
  const [isCheckedItems, setIsCheckedItems] = useState([]);
  const [isCheckedAllList, setIsCheckedAllList] = useState(false);

  // Update checked items whenever bookings prop changes
  useEffect(() => {
    if (bookings?.length > 0) {
      const updatedCheckedItems = bookings.map((booking) => ({
        id: booking?.order_id,
        checked: false,
      }));
      setIsCheckedItems(updatedCheckedItems);
    }else{
      setIsCheckedItems([]);
    }
  }, [bookings]);

  // Handle selecting/unselecting a single item
  const handleSingleChecked = (id) => {
    const updatedCheckedItems = isCheckedItems?.map((item) => {
      if (item.id === id) {
        return {
          ...item,
          checked: !item.checked,
        };
      }
      return item;
    });

    setIsCheckedItems(updatedCheckedItems);
    // Check if all items are selected
    const allChecked = updatedCheckedItems?.every((item) => item.checked);
    setIsCheckedAllList(allChecked);
  };

  // Handle selecting/unselecting all items
  const handleAllChecked = () => {
    const updatedCheckedItems = isCheckedItems?.map((item) => ({
      ...item,
      checked: !isCheckedAllList, // Toggle the checked state based on the current state of select all
    }));
    setIsCheckedItems(updatedCheckedItems);
    setIsCheckedAllList(!isCheckedAllList); // Toggle the select all state
  };

  // Calculate the number of selected items
  const selectedCount = isCheckedItems?.filter((item) => item.checked).length;

  const handleRedeemNow = async (items) => {
    try {
      const bodyData = items
        ?.filter((item) => item.checked)
        .map((item) => item.id); // Extract only the IDs of the selected items
      const response = await postMarkAsRedeem({ order_id: bodyData });
      if (response?.data) {
        toast.success(response?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
      if (response?.error) {
        toast.error(response?.error?.data?.message, {
          position: "top-center",
          autoClose: 3000,
        });
      }
    } catch (e) {
      toast.error(e?.message, {
        position: "top-center",
        autoClose: 3000,
      });
    } finally {
      setShowConfirmRedeemModal(false);
      const updatedCheckedItems = isCheckedItems?.map((item) => ({
        ...item,
        checked: false, // Reset all checkboxes
      }));
      setIsCheckedItems(updatedCheckedItems);
      setIsCheckedAllList(false);
    }
  };

  return (
    <div className="fp-booking-list">
      <div className="d-flex align-items-center gap-3 mb-3">
        {/* select all checkbox */}
        <div className="d-flex align-items-center gap-2">
          <Form.Check
            type="checkbox"
            name={"option"}
            disabled={isCheckedItems?.length === 0}
            checked={isCheckedAllList}
            onChange={handleAllChecked} // Toggle all checkboxes
            className={"radio-button"}
          />
          <p className="m-0 cp-label">Select All</p>
        </div>

        {/* booking id search box */}
        <div>
          <div className="fp-filters-search d-flex align-items-center gap-2">
            <span className="cp-label m-0 p-0"></span>
            <input
              type="text"
              placeholder="eg 48787"
              className="fp-filters-search-input"
              value={searchVoucherId}
              onChange={(e) => setSearchVoucherId(e.target.value)}
            />
            <button className="fp-bc-filters-search-btn">
              <Icon icon="pajamas:search" fontSize={18} color="white" />
            </button>
          </div>
        </div>

        {/* Conditionally render the "Redeem Now" button if any checkbox is selected */}
        {selectedCount > 0 && (
          <button
            onClick={() => setShowConfirmRedeemModal(true)}
            className={"fp-booking-redeemed-btn"}
          >
            Redeem Now ({selectedCount})
          </button>
        )}
      </div>

      {bookings &&
        bookings.length > 0 &&
        bookings.map((booking) => (
          <div
            className="d-flex align-items-center gap-2"
            key={booking?.order_id}
          >
            <Form.Check
              type="checkbox"
              id={booking?.order_id}
              name={"option"}
              checked={
                isCheckedItems?.find((item) => item.id === booking?.order_id)
                  ?.checked || false
              }
              onChange={() => handleSingleChecked(booking?.order_id)} // Toggle single checkbox
              className={"radio-button"}
            />
            <FBookingCard
              key={booking?.order_id}
              booking={booking}
              isPostMarkAsRedeemLoading={isPostMarkAsRedeemLoading}
              handleRedeem={handleRedeemNow}
            />
          </div>
        ))}

      {bookings && bookings.length == 0 && <NoBookingCard />}

      {/* Confirm Redeem Modal */}
      <ConfirmRedeemModal
        show={showConfirmRedeemModal}
        handleClose={() => setShowConfirmRedeemModal(false)}
        listItemsLength={selectedCount}
        isLoading={isPostMarkAsRedeemLoading}
        handleRedeem={() => handleRedeemNow(isCheckedItems)}
      />
    </div>
  );
}

export default FBookingCardsList;
